<template>
    <a :href="urlWishList">
        <button class="shop-nav__btn">
            <i class="icon__wish-list">
                <span class="shop-nav__wish-list-wrap" :class="{'shop-nav__wish-list-wrap--visible': wishListCount > 0}">
                    <span class="shop-nav__wish-list-amount">
                        {{ wishListCount }}
                    </span>
                </span>
            </i>
        </button>
    </a>
</template>

<script>
    export default {
        computed:
            {
                wishListCount()
                {
                    return this.$store.getters.wishListCount;
                },

                urlWishList()
                {
                    return App.urls.wishList;
                }
            }
    }
</script>

